/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../common/common/common.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../common/navigation/navigation.ts" />
/// <reference path="../main/main.ts" />

namespace OfficeGuy.CRM {
    export class EntityPicker {
        static Init(Container?: any) {
            $("input.entitypicker", Container).each(function () {
                var $Hidden = $(this);
                var $PickerContainer = $Hidden.closest(".entitypickercontainer");
                OfficeGuy.CRM.Main.$EntityMenu_Container = $PickerContainer;

                if (Teva.SelectBox.GetInstance($Hidden) != null)
                    return;

                var $SchemaID_Hidden = $(".schemaid:first", $PickerContainer);
                var $EntityName_Hidden = $(".entitytext:first", $PickerContainer);

                var HiddenValue = <string>$Hidden.val();
                var Separator = HiddenValue.indexOf('|');
                var ID;
                var Text;
                if (Separator != -1) {
                    ID = HiddenValue.substring(0, Separator);
                    Text = HiddenValue.substring(Separator + 1);
                }
                else if (HiddenValue == "" || HiddenValue == "0") {
                    ID = "0";
                    Text = EntityPicker.GetPlaceholderText($PickerContainer[0]);
                }
                else {
                    ID = HiddenValue;
                    Text = $Hidden.data("data-text");
                }
                $Hidden.val(ID);
                $Hidden.attr("data-text", Text);

                var Instance;
                Teva.SelectBox.Enable($Hidden, {
                    QueryMethod: $PickerContainer.data("disablepicker") == "1" ? null : function (Terms, QueryByID, PageIndex, Callback) {
                        EntityPicker.GetData($PickerContainer, Number($Hidden.data("schemaid")), 0, PageIndex, Terms, Callback);
                    },
                    CtrlClickEvent: function (Value, Data) {
                        if (Value == null || Value == "" || Value == "0" || Number(Value) < 0)
                            return true;

                        var SchemaID = null;
                        if (Data === undefined)
                            SchemaID = $SchemaID_Hidden.val();
                        else
                            SchemaID = Data.schemaid;
                        window.open("/f" + SchemaID + "/c" + Value + "/");
                        return false;
                    },
                    OnChange: function (ID, Text, Data, Instance, IsClearValue) {
                        var $Validation = Instance.$Input.closest(".sumit-field-value").find(".field-validation-valid, .field-validation-error")
                            .removeClass("field-validation-error").text("");

                        if (Data == null) {
                            $Hidden.val("0");
                            if (IsClearValue)
                                Text = "";
                            if (!IsClearValue && Text != null && Text.length > 0) {
                                $Validation
                                    .addClass("field-validation-error")
                                    .addClass("field-validation-error-newentity")
                                    .text("בעת השמירה יווצר כרטיס חדש בתיקייה");
                            }
                        }
                        if (Number(ID) < 0) {
                            $Validation
                                .addClass("field-validation-error")
                                .addClass("field-validation-error-newentity")
                                .text("בעת השמירה יווצר כרטיס חדש בתיקייה");
                        }

                        OfficeGuy.CRM.Main.$EntityMenu_Container = $PickerContainer;

                        $Hidden[0].setAttribute("data-text", Text);
                        $SchemaID_Hidden.val(Data == null ? $Hidden.data("schemaid") : Data.SchemaID == null ? Data.schemaid : Data.SchemaID);
                        $EntityName_Hidden.val(Text);
                    },
                    PlaceHolderText: EntityPicker.GetPlaceholderText($PickerContainer[0]),
                    AllowClear: true,
                    EmptyValue: "0",
                    AllowManualValues: !($PickerContainer.data("disablecreatenew") == "1" && $($PickerContainer.data("children")).length == 0) && $PickerContainer.data("quickcreate") == "1",
                    SelectFirstOnClose: !($PickerContainer.data("disablecreatenew") == "1" && $($PickerContainer.data("children")).length == 0) && $PickerContainer.data("quickcreate") == "1",
                    FooterCreate: $PickerContainer.data("disablecreatenew") == "1" && $($PickerContainer.data("children")).length == 0 ? null : function () {
                        OfficeGuy.CRM.Main.$EntityMenu_Container = $PickerContainer;
                        setTimeout(function () {
                            EntityPicker.ShowCreateMenu($PickerContainer, Instance.$SearchTermsInput.val());
                        }, 10);
                        return true;
                    },
                    FooterCreateText: $PickerContainer.data("disablecreatenew") == "1" && $($PickerContainer.data("children")).length == 0 ? null : OfficeGuy.Resources.GetString("CRM", "EntityPickerCreatePrefix") + $PickerContainer[0].getAttribute("data-schemasinglename"),
                    //FormatResultItem: Instance.$SearchTermsInput.data("formatresultitem") == null ? null : eval(Instance.$SearchTermsInput.data("formatresultitem"))
                });
                Instance = Teva.SelectBox.GetInstance($Hidden);
                if ($Hidden[0].getAttribute("data-schemaid") == "0")
                    Instance.Disable();

                if (!OfficeGuy.Common.IsPost)
                    EntityPicker.RefreshAdditionalData($PickerContainer, $Hidden);
            });
        }

        static GetPlaceholderText(PickerContainer) {
            var ToReturn = PickerContainer.getAttribute("data-placeholder");
            if (ToReturn == null || ToReturn.length == 0)
                ToReturn = OfficeGuy.Resources.GetString("CRM", "ChooseCard") + PickerContainer.getAttribute("data-schemasinglename");
            return ToReturn;
        }

        static RefreshAdditionalData($PickerContainer, $Hidden = null) {
            if ($Hidden == null)
                $Hidden = $PickerContainer.find("input.entitypicker");
            var ID = $Hidden.val();
            if (ID == "" || ID == "0" || Number(ID) <= 0 || !EntityPicker.HasAdditionalFields($PickerContainer))
                return;

            EntityPicker.GetData($PickerContainer, Number($Hidden.data("schemaid")), Number(ID), 0, null, function (Response) {
                if (Response.results.length == 0)
                    return;

                if ($Hidden.val() == ID)
                    Teva.SelectBox.GetInstance($Hidden).SetData(Response.results[0].data, true);
            });
        }

        static HasAdditionalFields($PickerContainer) {
            return $PickerContainer.data("additionalfields") !== undefined && $PickerContainer.data("additionalfields") != "";
        }
        static GetData_GetAdditionalField(Value) {
            if (Value == null || Value == "")
                return null;
            var Values = Value.toString().replace(/\./g, ',').split(',');
            if (Values.length == 0)
                return null;
            var ToReturn = new Array();
            ToReturn.push(Number(Values[0]));
            for (var i = 1; i < Values.length; i++)
                ToReturn.push(Number(Values[i]));
            return ToReturn;
        }
        static GetData($PickerContainer, SchemaID, EntityID, PageIndex, Term, Callback) {
            var Data: any = {
                SchemaID: SchemaID,
                Page: PageIndex + 1,
                Term: Term
            };
            var URL = "/crm/entitypicker/";
            if (EntityID != 0)
                Data.EntityID = Number(EntityID);
            if ($PickerContainer.data("viewid") !== undefined)
                Data.ViewID = Number($PickerContainer.data("viewid"));
            if ($PickerContainer.data("additionalfields") !== undefined && $PickerContainer.data("additionalfields") != "")
                Data["AdditionalFields"] = $PickerContainer.data("additionalfields");
            if ($PickerContainer.data("pickerpropertyid") !== undefined && $PickerContainer.data("pickerpropertyid") != "")
                Data["PickerPropertyID"] = $PickerContainer.data("pickerpropertyid");

            Common.AjaxRequest({
                URL: URL,
                Data: Data,
                SuccessMethod: function (Response) {
                    var ToReturn = {
                        more: Response.More,
                        results: []
                    };
                    for (var i = 0; i < Response.Results.length; i++)
                        ToReturn.results.push({
                            id: Response.Results[i].id,
                            text: Response.Results[i].label,
                            schemaid: Response.Results[i].schemaid,
                            data: {
                                schemaid: Response.Results[i].schemaid,
                                AdditionalFields: Response.Results[i].AdditionalFields,
                            }
                        });

                    Callback(ToReturn);
                },
                ShowLoading: false
            });
        }

        static ShowCreateMenu($PickerContainer, Text = null) {
            var $Hidden = $("input.entitypicker:first", $PickerContainer);
            var SchemaID = $Hidden.data("schemaid");

            if ($($PickerContainer.data("children")).length == 0) {
                EntityPicker.New($PickerContainer, SchemaID, Text, $PickerContainer.data("newurlparameters"));
                return;
            }

            var $Menu = $(document.createElement('div'))
                .addClass("modal-buttonspanel");
            var $Modal;

            if ($PickerContainer.data("disablecreatenew") != "1") {
                $(document.createElement('a'))
                    .addClass("modal-buttonspanel-item")
                    .attr("href", "#")
                    .on("click", function () {
                        OfficeGuy.Modals.Hide($Modal);
                        EntityPicker.New($PickerContainer, SchemaID, Text);
                        return false;
                    })
                    .text(OfficeGuy.Resources.GetString("CRM", "CreateCard") + " " + $PickerContainer[0].getAttribute("data-schemasinglename"))
                    .appendTo($Menu);
            }

            var $Children = $($PickerContainer.data("children"));
            $Children.each(function (Index, Child: any) {
                $(document.createElement('a'))
                    .addClass("modal-buttonspanel-item")
                    .attr("href", "#")
                    .on("click", function () {
                        OfficeGuy.Modals.Hide($Modal);
                        EntityPicker.New($PickerContainer, Child.ID, Text);
                        return false;
                    })
                    .text(OfficeGuy.Resources.GetString("CRM", "CreateCard") + " " + Child.Name)
                    .appendTo($Menu);
            });
            $Modal = OfficeGuy.Modals.ShowHTMLDialog({
                Title: OfficeGuy.Resources.GetString("CRM", "CreateCard") + " " + $PickerContainer[0].getAttribute("data-schemasinglename"),
                HTML: $Menu
            });
            return false;
        }

        static Remove(): boolean {
            var $PickerContainer = OfficeGuy.CRM.Main.$EntityMenu_Container;
            var $Hidden = $("input.entitypicker:first", $PickerContainer);
            var Instance = Teva.SelectBox.GetInstance($Hidden);
            Instance.HideResults();

            var $Container = $(OfficeGuy.CRM.Main.$EntityMenu_Container).closest("div[data-isproperty=true]");

            var IsMultiple = $PickerContainer.closest(".sumit-field-value").data("propertymultiple") == "1";
            if (!IsMultiple || $Container.is($Container.parent().children(".og-entity-property:last")))
                Instance.ClearValue();
            else
                $PickerContainer.closest("div[data-isproperty=true]").remove();
            Common.Tooltip_Hide();

            Teva.Navigation.FocusOnFirstField($PickerContainer);
            return false;
        }

        static New(PickerContainer, SchemaID, Text: string = null, AdditionalParameters: string = null): boolean {
            var $Hidden = $("input.entitypicker:first", PickerContainer);
            var $SchemaID_Hidden = $(".schemaid:first", PickerContainer);
            var PropertyID = PickerContainer.closest(".sumit-field-value").data("propertyid");
            var PropertyIDToIgnore = PropertyID === undefined || PropertyID == null ? null : -PropertyID;
            if (PropertyIDToIgnore != null) {
                if (AdditionalParameters == null)
                    AdditionalParameters = "";
                AdditionalParameters += "&propertytoignore=" + PropertyIDToIgnore;
            }

            $SchemaID_Hidden.val(SchemaID);
            EntityPicker.PopupEntityPicker(PickerContainer, SchemaID, Text, AdditionalParameters);
            var Instance = Teva.SelectBox.GetInstance($Hidden);
            Instance.ClearValue();

            return false;
        }

        static PopupCreateRelatedEntity(SchemaID, PropertyID, EntityID): void {
            var OriginalURL = window.location.href;
            OfficeGuy.Modals.ShowHTMLGetDialog({
                URL: "/f" + SchemaID + "/new/?relatedpropertyid=" + PropertyID + "&relatedentityid=" + EntityID + "&layout=pickermodal",
                FullURL: "/f" + SchemaID + "/new/?relatedpropertyid=" + PropertyID + "&relatedentityid=" + EntityID,
                ReplaceModal: true,
                ConvertToAjax: true,
                ConvertToAjax_PreRenderEvent: function (Data) {
                    if (Data.EntityID != null && Data.EntityID != 0) {
                        OfficeGuy.Modals.HideAll(true);
                        if ($("form.crmform_entities").length > 0)
                            OfficeGuy.Forms.SubmitForm('form.crmform_entities');
                        else
                            Navigation.Redirect(OriginalURL);
                    }
                }
            });
            window.event.stopPropagation();
        }
        static PopupEntityPicker(PickerContainer: any, SchemaID: number, Text: string = null, AdditionalParameters: any = null): boolean {
            var Instance = Teva.SelectBox.GetInstance($("input.entitypicker[type=hidden]:first", PickerContainer));
            var URL = "/f" + SchemaID + "/new/?layout=pickermodal";
            if (Text != null)
                URL += "&text=" + encodeURI(Text);
            if (AdditionalParameters != null)
                URL += AdditionalParameters;
            var ConvertToAjax_PreRenderEvent = function (Data) {
                Notifications.Show(Data.Notifications);
                if (Data.EntityID != null && Data.EntityID != 0) {
                    if (EntityPicker.HasAdditionalFields(PickerContainer)) {
                        EntityPicker.GetData(PickerContainer, SchemaID, Number(Data.EntityID), 0, null, function (Response) {
                            Instance.SetValue(Data.EntityID, Data.EntityName, Response.results[0].data);
                            Modals.Hide(Modal);
                        });
                    }
                    else {
                        Instance.SetValue(Data.EntityID, Data.EntityName, { schemaid: SchemaID });
                        Modals.Hide(Modal);
                    }
                    Instance.ClearCache();
                    return true;
                }
            };
            var Modal = OfficeGuy.Modals.ShowHTMLGetDialog({
                URL: URL,
                ConvertToAjax: true,
                ReplaceModal: true,
                ConvertToAjax_PreRenderEvent: ConvertToAjax_PreRenderEvent,
                HideEvent: function () {
                    Teva.Navigation.FocusOnFirstField(Instance.Container);
                }
            });
            return false;
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.CRM.EntityPicker.Init(Container);
});